import {
  GET_SCHEDULE_DATA_REQUEST,
  GET_SCHEDULE_DATA_SUCCESS,
  GET_SCHEDULE_DATA_ERROR,
  ADD_SCHEDULE_DATA_REQUEST,
  ADD_SCHEDULE_DATA_SUCCESS,
  ADD_SCHEDULE_DATA_ERROR,
  UPDATE_SCHEDULE_DATA_REQUEST,
  UPDATE_SCHEDULE_DATA_SUCCESS,
  UPDATE_SCHEDULE_DATA_ERROR,
  DELETE_SCHEDULE_DATA_REQUEST,
  DELETE_SCHEDULE_DATA_SUCCESS,
  DELETE_SCHEDULE_DATA_ERROR,
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";


export const addScheduleData = (token, values) => (dispatch) => {
  dispatch({ type: ADD_SCHEDULE_DATA_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}create/reportSchedule`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: { ...values },
  })
    .then((response) => {
      return dispatch({
        type: ADD_SCHEDULE_DATA_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: ADD_SCHEDULE_DATA_ERROR,
        payload: [],
      });
    });
};

export const getScheduleData = (token, values) => (dispatch) => {
  dispatch({ type: GET_SCHEDULE_DATA_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/reportSchedule`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: { report_id: values },
  })
    .then((response) => {
      return dispatch({
        type: GET_SCHEDULE_DATA_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_SCHEDULE_DATA_ERROR,
        payload: [],
      });
    });
};

export const updateScheduleData = (token, id, values) => (dispatch) => {
  dispatch({ type: UPDATE_SCHEDULE_DATA_REQUEST });
  return axios({
    method: "PUT",
    url: `${BASEURL}update/reportSchedule/${id}`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: { ...values },
  })
    .then((response) => {
      return dispatch({
        type: UPDATE_SCHEDULE_DATA_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: UPDATE_SCHEDULE_DATA_ERROR,
        payload: [],
      });
    });
};

export const deleteScheduleData = (token, id) => (dispatch) => {
  dispatch({ type: DELETE_SCHEDULE_DATA_REQUEST });
  return axios({
    method: "DELETE",
    url: `${BASEURL}delete/reportSchedule/${id}`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
  })
    .then((response) => {
      return dispatch({
        type: DELETE_SCHEDULE_DATA_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: DELETE_SCHEDULE_DATA_ERROR,
        payload: [],
      });
    });
};